module.exports = __webpack_public_path__ + "img/fitness.5a65264b.jpg";